import { render } from "./imageGalery.vue?vue&type=template&id=f0f1416a&scoped=true"
import script from "./imageGalery.vue?vue&type=script&lang=js"
export * from "./imageGalery.vue?vue&type=script&lang=js"

import "./imageGalery.vue?vue&type=style&index=0&id=f0f1416a&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f1416a"]])

export default __exports__